/** 열린 provider. 늘리면 이 union과 아래 두 표에 항목이 하나씩 붙는다. */
export type ProviderId = 'google' | 'naver'

/**
 * 화면에 서는 차례. Google이 먼저이고 네이버가 다음이다.
 *
 * 구글이 먼저 열려 쌓이는 계정의 첫 줄기가 거기서 나온다. 한 번 정한 자리를 뒤에 바꾸지
 * 않는다. 늘 첫 버튼을 누르던 손이 자리가 바뀐 뒤 다른 버튼을 누르면, 계정을 찾는 기준이
 * provider와 식별자 한 쌍이라 그 버튼은 로그인이 아니라 빈 공간을 하나 더 세우는 길이 된다.
 */
export const PROVIDER_IDS: readonly ProviderId[] = ['google', 'naver']

/*
 * provider 이름은 사전이 갖는다. 브랜드 표기가 화면 언어마다 갈릴 수 있어 문구와 같은 자리에
 * 두고, 이름을 끼우는 문장도 그 사전 안에서 어순째로 끝난다.
 */
